














































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { SHOW_SNACKBAR } from '../../common/constants';
import { eventBus } from '../../main';
import brandModule from '../../store/modules/brand.module';
import errorModule from '../../store/modules/error.module';
import { ASSET_URL } from '../../common/config';
import budtenderModule from '../../store/modules/budtender.module';
import Brand from '../../common/model/Brand';

@Component
export default class AdminDashboardPage extends Vue {
  cdnUrl = ASSET_URL;

  logoFile: File | null = null;

  iconFile: File | null = null;

  bannerImage: File | null = null;

  placeholderImg = require('@/assets/admin/placeholder.jpg');

  numberOfColors = 5;

  get totalColors(): number {
    if (!this.brand) {
      return this.numberOfColors;
    }
    return this.brand.color_palette.length > this.numberOfColors
      ? this.brand.color_palette.length
      : this.numberOfColors;
  }

  get fontColor(): string {
    return '#FFFFFF';
  }

  get secondaryColor(): string {
    return '#000000';
  }

  get brand(): Brand | undefined {
    if (!brandModule.brand) {
      return;
    }
    return brandModule.brand;
  }

  addColor(): void {
    this.numberOfColors += 1;
  }

  async previewPage(): Promise<void> {
    if (!brandModule.brand) { return; }
    await budtenderModule.selectBrand(brandModule.brand);
  }

  async updateBrand(): Promise<void> {
    const bannerFileArray: Array<File> = [];
    if (this.bannerImage !== null) {
      bannerFileArray.push(this.bannerImage);
    }

    await brandModule.updateBrand({
      brand: this.brand,
      logo: this.logoFile,
      banners: bannerFileArray,
      icon: this.iconFile,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(SHOW_SNACKBAR, 'Brand successfully updated.');
  }
}
